import { Link } from "react-router-dom";
import { BackButton, Spacer, Spacer10, Spacer100, Spacer25 } from "./Utils";


export function Faq() {
	return(

<div>
	<BackButton />
	<Spacer />
	<div className='center-flex'>
	<div className='document'>
	<div className='p animated-div'>

	<h1 id="main-title" className='primary-title centered-text'>Frequently Asked Questions</h1>
	<Spacer />
	<h1 id="about-continentalis-app" className='secondary-title centered-text'>About Continentalis App</h1>
		<Spacer />
	<h2 className='tertiary-title' id="what-is-a-día-hábil">
		How can I buy more cases?
	</h2>
	<p>
		This is very much a first verison of the application. We are working on integrating a payment method directly into the app for payment processing. For now, you have to buy new cases <Link className="link" to='https://continentalis.eu/shop'>here on our main website.</Link> We will apply the credits to your account within one business day.
	</p>
	<Spacer25 />
		<h2 className='tertiary-title'>
			What's with the profile page?
		</h2>
		<p>
			The profile page is really there for your convienience more than anything else. You shouldn't need to edit it unless you really want to. The Profile page will automatically fill itself in as you enter save data into an active case. Likewise, data entered in the Profile will autofill when you open up a case. Changing profile data will not affect already-opened cases, however.
		</p>
		<Spacer25 />

		<h2 className='tertiary-title'>What's with the Documents page?</h2>
		<p>
		The Briefcase page lets you import documents to carry them around in your briefcase "in the cloud". New documents added to any case will also automatically be added to your Briefcase.
		</p>
		<Spacer25 />

		<h2 className="tertiary-title">Document autofill</h2>
		<p>
			When you open up a new case, documents are imported from your Briefcase based on document type and what the case requires. However, this happens <strong>only</strong> when you open up a new case. If you later add new documents to your Briefcase, an empty case won't start adding documents willy-nilly. You'll need to import them from your Briefcase. We figure this both saves time at case creation, but also dosen't go editing your opened cases without your permission.
		</p>
		<Spacer25 />

		<h2 className='tertiary-title'>
			Can I use this app on my phone?	
		</h2>
		<p>
			Of course. However, given the fact that you will probably be dragging, dropping, signing things, and looking at full-page documents I can't say I personally recommend it. The app is meant to be used most easily on a tablet, laptop, or desktop. Although I hope the mobile experience is as good as can be expected given the nature of the app.
		</p>
		<Spacer25 />

		<h2 className="tertiary-title">
			Does the app submit cases to Mercurio/the Spanish Administration in real time?
		</h2>
		<p>
			No. And it never will due to the nature of what it has to do. Mercurio and these government websites are buggy, glitchy, slow, and awful. There is no feasible way we could offer a snappy app that offered a good user experience if the back end was interfacing with state websites in real time. It will always submit and receive things <i>promptly</i> if not in real time.
		</p>
		<Spacer25 />

		<h2 className='tertiary-title'>
			Will more types of procedures become available through this app?
		</h2>
		<p>
			Yes, in time! We are just starting with the Aux to Residency modification procedure so as not to be overwhelmed. We want to serve the customers we have well before expanding.
		</p>
		<Spacer25 />


		<h2 className='tertiary-title'>Something isn't working correctly</h2>
		<p>
			That's very possible. We are a two-person team with other jobs as well. Please fill out the <Link to='/contact' className="link">Contact Form</Link> (also in the side bar) and we will get back to you within one business day. This app will become more polished over time.
		</p>
		<Spacer25 />

		<h2 className='tertiary-title'>
			I have a suggestion about the app.
		</h2>
		<p>
			That's perfectly fine. The app is very much a work in progress. I as a dev and as the designer of this specific web app have many blind spots about as how customers actually use the software. Feel free to let us know in our <Link to="/contact" className="link">Contact</Link> form.
		</p>


	<Spacer100 />
	
	<h1 id="about-administrative-procedures-in-general" className='secondary-title centered-text'>
		About Administrative Procedures in General
	</h1>
	<Spacer />
	<h2 className='tertiary-title' id="what-is-a-día-hábil">
		What is a “<em>día hábil</em>?”
	</h2>
	<p>
		A “<em>día hábil</em>” is a <strong>business day</strong>, that is, any day
		other than Saturday, Sunday, or an official holiday.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="can-i-file-my-application-at-correos-or-by-mail">
		Can I file my application at <em>Correos</em> or by mail?
	</h2>
	<p>
		Recent regulatory changes require most applications to be filed
		electronically. Electronic filing is most advantageous as it creates a
		digital “paper trail” including the documents you file, exact dates and
		times of filing, etc.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="what-is-notification">What is “notification?”</h2>
	<p>
		Notification is a formal act in which you gain access to a government
		resolution or other act. In most cases, notification is
		<strong>not</strong> an email or an SMS, but formal access to the resolution
		or other act. In most cases processed through Continentalis, notification
		will occur electronically.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="how-soon-after-a-resolution-or-act-is-made-available-must-i-get-notified">
		How soon after a resolution or act is made available must I get notified?
	</h2>
	<p>
		As a general rule, you must get notified —access a resolution or other act
		made available to you by the government— within{" "}
		<strong>ten calendar days</strong> of the act being made available to you.
		Continentalis App will allow you to get notified electronically. Unless you
		opt out, Continentalis will automatically “get notified” on your behalf on
		the 10th calendar day, if you have not accessed the act.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="what-is-the-difference-between-a-term-and-a-deadline">
		What is the difference between a term and a deadline?
	</h2>
	<p>
		A term is the period of time allowed by legislation for a process to take
		place. For example, the law may establish a term of three months for the
		government to review an immigration case or it may establish a term of ten
		business days for you to comply with a<em>requerimiento</em>. A deadline is
		the last day of a term.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="what-is-silencio-administrativo">
		What is “<em>silencio administrativo</em>?”
	</h2>
	<p>
		“<em>Silencio administrativo</em>,” or administrative silence, is a legal
		precept whereby the government’s failure to meet the deadline to resolve
		your case produces an effect. In certain cases (e.g., renewals of residence
		permits), there is “<em>silencio administrativo positivo</em>,” or positive
		administrative silence, which is an authentic, if default, favorable
		resolution; the government must still resolve explicitly, but can only do so
		to confirm a favorable outcome. In most immigration and citizenship law
		cases, there is “<em>silencio administrativo negativo</em>,” which is a
		fictitious, presumed denial; the government must still resolve, but you may
		lodge an appeal before they do so.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="what-is-a-requerimiento">
		What is a “<em>requerimiento</em>?”
	</h2>
	<p>
		A “<em>requerimiento</em>” is an administrative act whereby the government
		requires you to provide additional information or documents for your case
		file. A <em>requerimiento</em> should only be issued for items which are
		required by law and which were either not filed or filed incorrectly in your
		application.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="how-long-do-i-have-to-comply-with-a-requerimiento">
		How long do I have to comply with a “<em>requerimiento</em>?”
	</h2>
	<p>
		As a general rule, you will be given ten business days to provide additional
		information or documents or, in lieu thereof, arguments.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="what-happens-if-i-miss-the-deadline-to-file-required-documents">
		What happens if I miss the deadline to file required documents?
	</h2>
	<p>
		If you miss the deadline to file documents required in a
		<em>requerimiento</em>, the government can consider that you do not intend
		to comply and <strong>archive</strong> your case due to implicit withdrawal
		due to disinterest. However, until the government notifies you a resolution
		to archive your case, you may be able to provide the required documents or
		information. Talk to a lawyer.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="what-is-a-declaración-responsable">
		What is a “<em>declaración responsable</em>?”
	</h2>
	<p>
		A “<em>declaración responsable</em>,” or responsible declaration, is a
		written statement whereby you represent that you meet certain requirements
		or possess certain characteristics, qualifications, licenses, or
		authorizations. A responsible declaration can, in some cases, be filed in
		lieu of documents directly related to the aforementioned characteristics,
		qualifications, licenses, or authorizations.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="can-i-file-copies-of-documents-instead-of-originals">
		Can I file copies of documents instead of originals?
	</h2>
	<p>
		As a general rule, administrative law permits filing copies of documents
		unless a specific law or regulation requires originals. Additionally, the
		government can, exceptionally, request to see your original documents in
		order to compare them to copies. That said, a copy of a copy of a document
		(e.g., a scanned copy of a copy of your diploma) is likely to raise flags.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="can-i-make-a-filing-if-i-do-not-have-all-the-required-documents">
		Can I make a filing if I do not have all the required documents?
	</h2>
	<p>
		As a general rule, you can file a partial application. However, we recommend
		that your application is as complete as possible in order to avoid delays
		and the possibility of dismissal. Dismissal is a likely outcome if your
		filing is missing critical documents, such as documents proving your
		identity.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="do-i-have-to-translate-my-documents">
		Do I have to translate my documents?
	</h2>
	<p>
		If a document other than a passport is written in a language other than
		Spanish —or Catalan in Catalonia, Euskera in Basque Country, Valencian in
		Valencia, or Galego in Galicia— you must translate your documents to Spanish
		—or to a co-official language, as the case may be. There are exceptions for
		certain EU documents.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="do-i-have-to-use-a-sworn-translator">
		Do I have to use a sworn translator?
	</h2>
	<p>
		As a general rule, there is no legal requirement to use a sworn translator.
		Some procedures explicitly require sworn translations, but the laws and
		regulations surrounding most immigration procedures do not. It is general
		administrative practice, however, to require sworn translations.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="do-i-have-to-legalize-or-apostille-my-documents">
		Do I have to legalize or apostille my documents?
	</h2>
	<p>
		As a general rule, all foreign public documents must be legalized or
		apostilled. This allows the Spanish government to know that the document is
		an authentic document issued by a public authority in the country of
		issuance. Some documents, such as passports and certain EU documents, are
		exempt from legalization or apostille. Private documents (e.g., bank
		records) do not need to be legalized or apostilled.
	</p>
	<Spacer25 />
	<h2 className='tertiary-title' id="do-i-need-to-provide-continentalis-or-its-qualified-representatives-a-power-of-attorney">
		Do I need to provide Continentalis or its qualified representatives a power
		of attorney?
	</h2>
	<p>
		In most instances, neither Continentalis nor its representatives need powers
		of attorney to represent you. In certain cases, such as citizenship
		applications filed electronically, that is, without an attorney appearing on
		your behalf at a bar association, you will need to provide Continentalis or
		members of its pool of representatives a power of attorney. Additionally,
		even in cases where presumed representation applies, the government may
		singularly require you to provide a power of attorney.
	</p>
	<Spacer100 />
	<h1 id="about-immigration-procedures" className='secondary-title centered-text'>About Immigration Procedures</h1>
	<Spacer />
	<h2 className='tertiary-title' id="what-is-meant-by-full-passport">What is meant by “full passport?”</h2>
	<p>
		In many application types, we will ask you to upload a scan of your full
		passport (or a full scan of your passport, or a scanned copy of your
		passport in full, etc.). This
	</p>
	<Spacer25 />
</div></div></div></div>

	);
}
